<template>
  <div v-if="loadingStatus" class="text-center loading-wrapper">
    <div class="loading-container">
      <template>
        <v-sheet class="mt-10">
          <v-row class="px-10 mb-15">
            <v-col>
              <v-skeleton-loader width="50%" type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader width="100%" type="text" class="mb-8"></v-skeleton-loader>
              <v-skeleton-loader type="chip" class="mb-10"></v-skeleton-loader
            ></v-col>
            <v-col></v-col>
          </v-row>

          <v-row class="mt-16 px-10 pt-15 white">
            <v-col class="pb-0">
              <v-skeleton-loader width="40%" type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader width="60%" type="text" class="mb-5"></v-skeleton-loader>
              <v-skeleton-loader width="40%" type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader width="60%" type="text" class="mb-5"></v-skeleton-loader>
              <v-skeleton-loader width="40%" type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader width="60%" type="text" class="mb-5"></v-skeleton-loader>
            </v-col>
            <v-col style="position:relative">
              <v-skeleton-loader type="image" class="skeleton-bottle"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="mt-0 px-10 pb-10 white">
            <v-col>
              <v-skeleton-loader width="40%" type="text" class="mb-1"></v-skeleton-loader>
              <v-skeleton-loader width="60%" type="text" class="mb-5"></v-skeleton-loader>
            </v-col>
            <v-col></v-col>
          </v-row>
        </v-sheet>
      </template>
    </div>
  </div>
  <wine v-else :wine="wine"></wine>
</template>

<script>
import Wine from '../components/Wine.vue'
import _ from 'lodash'
export default {
  name: 'Vino',
  computed: {
    wine() {
      return _.find(this.$store.state.data, {
        id: this.$route.params.id
      })
    },
    loadingStatus() {
      return this.$store.getters.loadingStatus
    }
  },
  props: {
    id: String // in realtà dovrebbe essere lo slug al momento uso l'id
  },
  components: {
    Wine
  }
}
</script>
<style>
.skeleton-bottle {
  position: absolute;
  width: 35%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.skeleton-bottle .v-skeleton-loader__image {
  height: 350px;
}
</style>
